import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResultType } from '../../../../../models/enums/result-type.enum';
import { ManagementApiService } from '../../../../../services';
import { UserMatrixRowModel } from '../../../models/user-matrix-row-model';
import { SuccessDialogComponent } from 'src/app/shared/info-dialogs/success-dialog/success-dialog.component';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
@Component({
    selector: 'app-matrix-row-modify',
    templateUrl: './matrix-row-modify.component.html',
    styleUrls: ['./matrix-row-modify.component.scss'],
})
export class MatrixRowModifyComponent implements OnInit {
    @Input() userMatrixRowId: string;
    @Input() userMatrixJointId: string;
    @Output() refreshMatrixrow: EventEmitter<boolean> = new EventEmitter();

    tooltip_position = 'above';
    closeResult: string;
    result: ResultType = ResultType.Success;
    matrixRowModifyFormGroup: UntypedFormGroup;
    isJointIdEdit: boolean;

    constructor(
        private modalService: NgbModal,
        private fb: UntypedFormBuilder,
        private mgmtApi: ManagementApiService,
        private globalEmittersService: GlobalEmittersService,
        private userUtilityService: UserUtilityService
    ) {
        this.isJointIdEdit = false;
    }

    async ngOnInit(): Promise<void> {
        // * checking access level
        this.isJointIdEdit = await this.userUtilityService.checkUserPermissionDataAndRoute('matrix', userActions.Edit);
        this.matrixRowModifyFormGroup = this.fb.group({
            jointId: [this.userMatrixJointId, Validators.required],
        });
    }

    open(content) {
        this.modalService
            .open(content, {
                ariaLabelledBy: 'modal-basic-title',
                backdrop: 'static',
                windowClass: 'my_modal_class',
                size: 'md',
                keyboard: false,
            })
            .result.then(
                (result) => {
                    this.closeResult = `Closed with: ${result}`;
                },
                (reason) => {
                    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                }
            );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    updateJointId() {
        if (this.matrixRowModifyFormGroup.valid) {
            let matrixRowModel: UserMatrixRowModel = new UserMatrixRowModel();
            matrixRowModel.userMatrixRowId = this.userMatrixRowId;
            matrixRowModel.jointID = this.matrixRowModifyFormGroup.get('jointId').value;
            this.updateMatrixRow([matrixRowModel]);
            this.modalService.dismissAll();
        }
    }

    async updateMatrixRow(matrixRowModel: UserMatrixRowModel[]) {
        let result = await this.mgmtApi.updateMatrixRow(matrixRowModel).toPromise();
        if (result.success === true) {
            let dialogRef = this.modalService.open(SuccessDialogComponent, {
                size: 'md',
            });
            dialogRef.componentInstance.message = 'Matrix Joint Id changed sucessfully!';
            this.globalEmittersService.refreshMatrix.subscribe((res) => {
                if (res === true) {
                    this.refreshMatrixrow.emit(true);
                }
            });
        } else {
            this.userUtilityService.errorModelPopup(result.message);
        }
    }

    handleInputEvent(event: KeyboardEvent, typeOfValidation?: string) {
        const charCode = event.key;
        if (!/^[a-zA-Z0-9- ]$/.test(charCode)) {
            event.preventDefault();
        }
    }
}
